import { RS_API_URI } from "@api/session";

import { queryString, sessionPrefix } from "./helpers";

export const todosPath = (session: LightSessionInterface, args: QueryStringType = null) =>
  `${sessionPrefix(session)}/todos${queryString(args)}`;
export const newTodoPath = (session: LightSessionInterface, args: QueryStringType = null) =>
  `${sessionPrefix(session)}/todos/new${queryString(args)}`;
export const editTodoPath = (session: LightSessionInterface, todo: TodoRef, args: QueryStringType = null) =>
  `${sessionPrefix(session)}/todos/${todo.id}/edit${queryString(args)}`;
export const showTodoPath = (session: LightSessionInterface, todo: TodoRef, args: QueryStringType = null) =>
  `${sessionPrefix(session)}/todos/${todo.id}${queryString(args)}`;

export const todoAttachmentUrl = (todo: TodoRef) => `${RS_API_URI}/todos/${todo.id}`;
